// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataTable .dataGrid {
  background: white;
  padding: 20px;
}
.dataTable .dataGrid .MuiDataGrid-toolbarContainer {
  flex-direction: row-reverse;
}
.dataTable .dataGrid img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/dataTable/dataTable.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,aAAA;AAAJ;AAEI;EACE,2BAAA;AAAN;AAGI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADN","sourcesContent":[".dataTable {\n  .dataGrid {\n    background: white;\n    padding: 20px;\n\n    .MuiDataGrid-toolbarContainer {\n      flex-direction: row-reverse;\n    }\n\n    img {\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      object-fit: cover;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
